export default "__VITE_ASSET__B7Xgg9_i__"